import { format } from 'date-fns'
import React, { useState, useEffect, useContext } from 'react'
import Spinner from '../../../components.js/elements/Spinner'
import HeaderReturn from '../../../components.js/serveur/siteWeb/HeaderReturn'
import { useLocation } from 'react-router-dom'
import useFirebase from './../../../firebase/useFirebase'
import { AppContext } from '../../../App'
import ModalAddDaysCloseStaff from '../../../components.js/serveur/staff/ModalAddDaysCloseStaff'
import ButtonModalOpen from '../../../components.js/elements/ButtonModalOpen'


const AbsencesStaff = () => {
    const { user } = useContext(AppContext)
    const [montage, setMontage] = useState(true)
    const { writeData, deleteData, readData, datesOff } = useFirebase()
    const location = useLocation()
    const { state } = location

    useEffect(() => {
        readData(user.uid)
        window.scrollTo(0, 0)
        setMontage(false)
    },[]) 

    if (montage) return <Spinner />

    const _updateDates = (start, end) => {
        const startDate = format(new Date(start), 'MM/dd/yyyy')
        const endDate = format(new Date(end), 'MM/dd/yyyy')
        const dateDebut = format(new Date(start), 'dd/MM/yyyy')
        const dateFin = format(new Date(end), 'dd/MM/yyyy')
        const data = {startDate:startDate, endDate:endDate, idStaff:state.idStaff,dateDebut:dateDebut,dateFin:dateFin}
        writeData('entreprises/'+user.uid+'/datesOff/',data)
    }

    const _delete = (id) => {
        deleteData('entreprises/'+user.uid+'/datesOff/'+id)
    }

    return (
        <div className='container-fluid'>

            <HeaderReturn
                title={'Absences ' + state.surnameStaff +' ' + state.nameStaff}
                link='/staff'
            />

            <div className='shadow row mt-3'>
                <div className='card-body'>

                    {/* BUTTON ADD DATE */}
                    <ButtonModalOpen
                        title='Ajouter une date'
                        modal='modalAddDaysCloseStaff'
                    />

                    {datesOff.filter(d => d.idStaff === state.idStaff).sort((a,b) => new Date(a.startDate) > new Date(b.startDate) ? 1 : -1).map(d => (
                        <div className='row border-top mt-3' key={d.id}>
                            <div className='col mt-3'>
                                <div>du {d.dateDebut} au {d.dateFin}</div>
                            </div>
                            <div className='col text-end mt-3'>
                                <u style={{ cursor:'pointer' }} onClick={() => _delete(d.id)}>Supprimer</u>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <ModalAddDaysCloseStaff
                _updateDates={_updateDates} 
            /> 
            
            <div style={{ height:400 }} />
        </div>
    )
}

export default AbsencesStaff